import type { IconJVSProps } from '@mairistem/composants';
import React from 'react';
import type TypeRegroupement from '../../constants/feuilleSaisie/typeRegroupement';
import TypePeriode from '../../constants/simulation/typePeriode';
import type TreeRow from '../../interfaces/feuilleSaisie/treeRow';
import { getMontantImputation } from '../../utils/feuilleSaisie/imputation';
import type BaseFeuilleSaisie from '../feuilleSaisies/BaseFeuilleSaisie';

class BaseTypeRegroupement {
	code: TypeRegroupement;

	libelle: string;

	// nom de la colone en base de données qui contient le code
	codeColumnName: string;

	// libelle de la colonne en base de données qui contient le libelle
	libelleColumnName: string;

	icon: IconJVSProps;

	getKey(data: TreeRow): string {
		return this.code + data[this.codeColumnName];
	}

	getLibelle(data: TreeRow, _feuille: BaseFeuilleSaisie): string {
		return `${data[this.codeColumnName] ?? ''} - ${data[this.libelleColumnName] ?? ''}`;
	}

	getTabLibelle(data: TreeRow): React.JSX.Element {
		return (
			<>
				<div>{data[this.codeColumnName] ?? ''}</div>
				{data[this.libelleColumnName] ?? ''}
			</>
		);
	}

	getSolde(data: TreeRow) {
		return {
			libelle: 'TOTAL',
			...data?.children?.reduce(
				(prev, next) => ({
					solde: prev.solde + next.solde,
					budget: prev.budget + next.budget,
					budget_n1: prev.budget_n1 + next.budget_n1,
					budget_n2: prev.budget_n2 + next.budget_n2,
					realise: prev.realise + next.realise,
					realise_n1: prev.realise_n1 + next.realise_n1,
					realise_n2: prev.realise_n2 + next.realise_n2,
					bp_n1: prev.bp_n1 + next.bp_n1,
					bp_n2: prev.bp_n2 + next.bp_n2,
					report: prev.report + next.report,
					rar: prev.rar + next.rar,
					engage_n: prev.engage_n + next.engage_n,
					liquide_n: prev.liquide_n + next.liquide_n,
					montant_demande:
						prev.montant_demande +
						getMontantImputation(next, TypePeriode.DEMANDE),
					montant_propose:
						prev.montant_propose +
						getMontantImputation(next, TypePeriode.PROPOSE),
					montant_vote:
						prev.montant_vote + getMontantImputation(next, TypePeriode.VOTE),
				}),
				{
					budget: 0,
					budget_n1: 0,
					budget_n2: 0,
					realise: 0,
					realise_n1: 0,
					realise_n2: 0,
					bp_n1: 0,
					bp_n2: 0,
					montant_demande: 0,
					montant_propose: 0,
					montant_vote: 0,
					report: 0,
					rar: 0,
					engage_n: 0,
					liquide_n: 0,
					solde: 0,
				},
			),
		};
	}
}

export default BaseTypeRegroupement;
